
export const standardQueueFairRoutes: string[] = [
  // '/e/test-261101', '/e/C4sI80tEQYTTXW31Cm8l',
  // '/e/djoti2026', '/e/xObqvYT12IA5BMz6qrMG',
];

export const ticketQueueFairRoutes: string[] = [
  // '/test-261101', '/C4sI80tEQYTTXW31Cm8l',
  // '/e/djoti2026', '/e/xObqvYT12IA5BMz6qrMG',
];

export const siofokQueueFairRoutes: string[] = [
  // '/e/test-261101', '/e/C4sI80tEQYTTXW31Cm8l',
  // '/e/djoti2026', '/e/xObqvYT12IA5BMz6qrMG',
];

export const embeddedQueueFairRoutes: string[] = [
  // '/e/test-261101', '/e/C4sI80tEQYTTXW31Cm8l',
  // '/e/djoti2026', '/e/xObqvYT12IA5BMz6qrMG',
];
